import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./assets/css/main.css";
import { makeServer } from "@/axios/mirage";
import VueProgressBar from "vue-progressbar";
import moment from "moment";
import "moment/locale/id"; // without this line it didn't work
moment.locale("id");

const options = {
  color: "blue", // '#bffaf3',
  failedColor: "#874b4b",
  thickness: "3px",
  transition: {
    speed: "0.1s",
    opacity: "0.3s",
    termination: 300
  },
  autoRevert: true,
  location: "top",
  inverse: false
};
const ignoreWarnMessage =
  "The .native modifier for v-on is only valid on components but it was used on <div>.";
Vue.config.warnHandler = function(msg, vm, trace) {
  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
};
Vue.config.productionTip = false;

Vue.use(VueProgressBar, options);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");

// if (process.env.NODE_ENV === "development") {
//   makeServer();
// }

// export const httpBaseUrl = 'api';
